enum ServiceDisabledReason {
  MaxExceeded = 'maxExceeded',
  Included = 'included',
}

export default ServiceDisabledReason;
